<template>
  <div class="modal-overlay" @click.self="modalStore.closeAllModals()">
    <div class="modal-window">
      <div class="modal-content">
        <div class="modal-text-container">
          <h2 class="modal-title">Регистрация</h2>

          <!-- 📞 Телефон с маской -->
          <PhoneInput
            v-model="phone"
            :disabled="isLoading"
            @valid="isPhoneValid = $event"
            placeholder="+7 900 000-00-00"
          />

          <!-- 🔑 Пароль -->
          <input
            v-model="password"
            class="modal-input"
            type="password"
            placeholder="Придумайте пароль"
            :disabled="isLoading"
            @keyup.enter="register"
          />

          <!-- ▶ Кнопка регистрации -->
          <button
            class="button-1"
            @click="register"
            :disabled="isLoading || !isFormValid"
            :class="{ loading: isLoading }"
          >
            <span>{{ isLoading ? 'Регистрируем...' : 'Зарегистрироваться' }}</span>
          </button>

          <!-- ✅ Успешная регистрация -->
          <div v-if="successMessage" class="success-message">
            <p>Откройте телеграм бота Танцуй Россия, нажмите старт чтобы подтвердить Ваш номер телефона</p>
            <a
              href="https://t.me/dance_russia_bot"
              target="_blank"
              class="bot-link"
              @click="handleBotLinkClick"
            >
              Открыть @dance_russia_bot
            </a>
          </div>

          <!-- 🔔 Ошибка -->
          <div v-if="notification && !successMessage" class="modal-toast error">
            {{ notification }}
          </div>
        </div>
      </div>

      <button class="modal-close" @click="modalStore.closeAllModals()">✖</button>
    </div>
  </div>
</template>

<script>
import PhoneInput from '@/components/modals/PhoneInput.vue'
import { useAuthStore } from '@/stores/auth'
import { useModalStore } from '@/stores/modals'
import { useReCaptcha } from 'vue-recaptcha-v3'

export default {
  name: 'RegisterModal',

  components: {
    PhoneInput
  },

  // Пропс phone больше не нужен — PhoneInput сам управляет состоянием
  // emits: ['update:phone'] — тоже не нужно

  setup() {
    const authStore = useAuthStore()
    const modalStore = useModalStore()
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

    return { authStore, modalStore, executeRecaptcha, recaptchaLoaded }
  },

  data() {
    return {
      phone: '',                // ← сюда приходит уже нормализованный +7916...
      isPhoneValid: false,
      password: '',
      notification: '',
      successMessage: false,
      isLoading: false,
      notifyTimer: null
    }
  },

  computed: {
    isFormValid() {
      return this.isPhoneValid && this.password.length >= 4
    }
  },

  methods: {
    handleBotLinkClick() {
      this.modalStore.openLoginModal()
    },
    showToast(message, duration = 4000) {
      this.notification = message
      clearTimeout(this.notifyTimer)
      this.notifyTimer = setTimeout(() => {
        this.notification = ''
      }, duration)
    },

    async register() {
      if (this.isLoading || !this.isFormValid) return

      this.isLoading = true
      this.successMessage = false
      this.notification = ''

      // phone уже в формате +79161234567 благодаря PhoneInput
      const formattedPhone = this.phone

      try {
        await this.recaptchaLoaded()
        const recaptchaToken = await this.executeRecaptcha('register')

        const formData = new FormData()
        formData.append('phone', formattedPhone)
        formData.append('password', this.password)
        formData.append('recaptcha_token', recaptchaToken)

        const res = await fetch('https://dancerus.ru/api/register.php', {
          method: 'POST',
          body: formData
        })

        const data = await res.json()

        if (data.status === 'success') {
          this.successMessage = true
          // Можно добавить автозакрытие через время, если нужно
        } else {
          this.showToast(data.message || 'Ошибка регистрации')
        }
      } catch (err) {
        console.error(err)
        this.showToast('Ошибка сети или reCAPTCHA')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@use "@/styles/mixins.scss";

/* Если нужно, можно стилизовать success-message и bot-link */
.success-message {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: #4caf50;
}

.bot-link {
  display: block;
  margin-top: 12px;
  padding: 10px;
  background: #0088cc;
  color: white;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
}
</style>